import { useQuery } from "@tanstack/react-query";
import api from "./api";
import { useAuth } from "../context/AuthContext";

export function usePerms() {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  const { data, isSuccess } = useQuery({
    queryKey: ["permissions"],
    queryFn: async () => (await api.get("/permissions")).data,
    staleTime: 60000,
    enabled: !!user,
  });
  const caps = new Set(data?.my_caps || []);
  return { loaded: isAdmin || isSuccess, isAdmin, can: (cap) => isAdmin || caps.has(cap) };
}
